import MessageError from '@/core/components/MessageError.vue'
export default {
    components: { MessageError },
    props: {
        operation: { type: String, default: '', required: true },
        toCopy: { type: Object, required: false }
    },
    data(){
        return {
            deletedId: null
        }
    },
    watch:{
        toCopy(val){
            if(val.id) this.form = val
            else this.reset()
        }
    },
    methods:{
        checkIfRequired(value){ 
            if(value.$params && Object.keys(value.$params).indexOf('required') !== -1){
                return true
            }
            return false
        },
        reset(id){
            this.$v.form.$reset()
            if(id) this.deletedId = id
            this.form = Object.assign({}, this.$data.init)
        }
    },
    
}
